import { render, staticRenderFns } from "./BankInstallments.vue?vue&type=template&id=4363c0ba"
import script from "./BankInstallments.vue?vue&type=script&lang=js"
export * from "./BankInstallments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports